const appVersion = process.env.VERSION;
export default appVersion;
